import React, { useEffect, useState } from 'react'

import { Row, Col, Typography } from 'antd'

import { api, request } from '../../../../util/handlerRequestUtil'
import EmptyData from '../../../../assets/images/ico_dashboard.svg'
import { renderEibActionsGraph } from '../../EibActionGraphs'

import './styles.css'

export const EibPlannedActions = ({ filter }) => {
  const [data, setData] = useState({
    regionChart: [],
    districtChart: [],
    category: []
  })

  useEffect(() => {
    if (filter.safra_id) {
      fechtEibDashActionData(filter)
    }
  }, [filter])

  //Fetch data
  async function fechtEibDashActionData(filter) {
    let wasTouched = false

    if (filter.safra_id) {
      wasTouched = filter.safra_id != '-1' || filter.marca_id != '-1'
    }

    try {
      let { parsedRegionData, parsedDistrictData, chartCategories } = await request(
        api.EibDashActionData({ ...filter, type: 'planejada' })
      )
      setData({
        ...data,
        regionChart: wasTouched === true ? parsedRegionData : parsedRegionData,
        districtChart: wasTouched === true ? parsedDistrictData.slice(0, 10) : parsedDistrictData.slice(0, 10),
        category: chartCategories || []
      })
    } catch (error) {
      console.error({ error })
    }
  }
  if (data && data.category.length > 0) {
    return (
      <Row gutter={[16, 16]} style={{ fontSize: 11, color: '#8591A1' }}>
        <h3 style={{ fontSize: 14, fontWeight: 500, color: '#263447' }}>Quantidade de Ações Planejadas</h3>
        <Col
          span={24}
          style={{ display: 'flex', justifyContent: 'space-between', textAlign: 'center', alignItems: 'center' }}
        >
          <div className="container-card" style={{ width: '45%' }}>
            {renderEibActionsGraph(data.regionChart, data.category, 'por Regional', 'region')}
          </div>
          <div className="container-card" style={{ width: '45%' }}>
            {renderEibActionsGraph(data.districtChart, data.category, 'por Distrito', 'district')}
          </div>
        </Col>
      </Row>
    )
  } else {
    return (
      <div style={{ width: '100%' }}>
        <div style={{ display: 'grid', placeItems: 'center', padding: 14, height: '52vh', background: '#F1F3F5' }}>
          <img src={EmptyData} alt="FarmIcon" style={{ marginBottom: -30 }} />
          <Typography style={{ color: '#8591A1', fontWeight: 'bold', textAlign: 'center', fontSize: 18 }}>
            {'Sem dados'}
          </Typography>
          <Typography
            style={{ color: '#8591A1', fontWeight: '500', textAlign: 'center', fontSize: 18, marginTop: -50 }}
          >
            {'Aplique ou altere o filtro para'}
          </Typography>
          <Typography
            style={{ color: '#8591A1', fontWeight: '500', textAlign: 'center', fontSize: 18, marginTop: -120 }}
          >
            {'exibir dados.'}
          </Typography>
        </div>
      </div>
    )
  }
}
